"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var InvoiceApi = /** @class */ (function (_super) {
    __extends(InvoiceApi, _super);
    function InvoiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Downloads an invoice
     */
    InvoiceApi.prototype.downloadInvoiceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadInvoice.');
                        }
                        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
                            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling downloadInvoice.');
                        }
                        if (requestParameters.invoiceSuffixId === null || requestParameters.invoiceSuffixId === undefined) {
                            throw new runtime.RequiredError('invoiceSuffixId', 'Required parameter requestParameters.invoiceSuffixId was null or undefined when calling downloadInvoice.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.erp !== undefined) {
                            queryParameters['erp'] = requestParameters.erp;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice/{invoiceId}/{invoiceSuffixId}/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "invoiceId" + "}", encodeURIComponent(String(requestParameters.invoiceId))).replace("{" + "invoiceSuffixId" + "}", encodeURIComponent(String(requestParameters.invoiceSuffixId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads an invoice
     */
    InvoiceApi.prototype.downloadInvoice = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadInvoiceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads invoices as a zip
     */
    InvoiceApi.prototype.downloadInvoicesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadInvoices.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.isCombined !== undefined) {
                            queryParameters['isCombined'] = requestParameters.isCombined;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.DownloadInvoicesRequestToJSON(requestParameters.downloadInvoicesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads invoices as a zip
     */
    InvoiceApi.prototype.downloadInvoices = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadInvoicesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads the selected invoices from a server generated download link
     */
    InvoiceApi.prototype.downloadInvoicesByLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadInvoicesByLink.');
                        }
                        if (requestParameters.token === null || requestParameters.token === undefined) {
                            throw new runtime.RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling downloadInvoicesByLink.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling downloadInvoicesByLink.');
                        }
                        if (requestParameters.combined === null || requestParameters.combined === undefined) {
                            throw new runtime.RequiredError('combined', 'Required parameter requestParameters.combined was null or undefined when calling downloadInvoicesByLink.');
                        }
                        if (requestParameters.invoices === null || requestParameters.invoices === undefined) {
                            throw new runtime.RequiredError('invoices', 'Required parameter requestParameters.invoices was null or undefined when calling downloadInvoicesByLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.token !== undefined) {
                            queryParameters['token'] = requestParameters.token;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.combined !== undefined) {
                            queryParameters['combined'] = requestParameters.combined;
                        }
                        if (requestParameters.invoices !== undefined) {
                            queryParameters['invoices'] = requestParameters.invoices;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/link/user/admin/customer/{customerId}/invoice/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads the selected invoices from a server generated download link
     */
    InvoiceApi.prototype.downloadInvoicesByLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadInvoicesByLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads the selected invoices from a server generated download link
     */
    InvoiceApi.prototype.downloadPaymentRemittanceFileByLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.filename === null || requestParameters.filename === undefined) {
                            throw new runtime.RequiredError('filename', 'Required parameter requestParameters.filename was null or undefined when calling downloadPaymentRemittanceFileByLink.');
                        }
                        if (requestParameters.token === null || requestParameters.token === undefined) {
                            throw new runtime.RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling downloadPaymentRemittanceFileByLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.token !== undefined) {
                            queryParameters['token'] = requestParameters.token;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/link/finance/remittance/{filename}/download".replace("{" + "filename" + "}", encodeURIComponent(String(requestParameters.filename))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads the selected invoices from a server generated download link
     */
    InvoiceApi.prototype.downloadPaymentRemittanceFileByLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadPaymentRemittanceFileByLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads a statement
     */
    InvoiceApi.prototype.downloadStatementRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadStatement.');
                        }
                        if (requestParameters.statementDate === null || requestParameters.statementDate === undefined) {
                            throw new runtime.RequiredError('statementDate', 'Required parameter requestParameters.statementDate was null or undefined when calling downloadStatement.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.excludePaidInvoices !== undefined) {
                            queryParameters['excludePaidInvoices'] = requestParameters.excludePaidInvoices;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/statement/{statementDate}/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "statementDate" + "}", encodeURIComponent(String(requestParameters.statementDate))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads a statement
     */
    InvoiceApi.prototype.downloadStatement = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadStatementRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads statements as a zip
     */
    InvoiceApi.prototype.downloadStatementsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadStatements.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.excludePaidInvoices !== undefined) {
                            queryParameters['excludePaidInvoices'] = requestParameters.excludePaidInvoices;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/statement/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.DownloadStatementsRequestToJSON(requestParameters.downloadStatementsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads statements as a zip
     */
    InvoiceApi.prototype.downloadStatements = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadStatementsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads the selected statements from a server generated download link
     */
    InvoiceApi.prototype.downloadStatementsByLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadStatementsByLink.');
                        }
                        if (requestParameters.token === null || requestParameters.token === undefined) {
                            throw new runtime.RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling downloadStatementsByLink.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling downloadStatementsByLink.');
                        }
                        if (requestParameters.statements === null || requestParameters.statements === undefined) {
                            throw new runtime.RequiredError('statements', 'Required parameter requestParameters.statements was null or undefined when calling downloadStatementsByLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.token !== undefined) {
                            queryParameters['token'] = requestParameters.token;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.statements !== undefined) {
                            queryParameters['statements'] = requestParameters.statements;
                        }
                        if (requestParameters.excludePaidInvoices !== undefined) {
                            queryParameters['excludePaidInvoices'] = requestParameters.excludePaidInvoices;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/link/user/admin/customer/{customerId}/statement/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads the selected statements from a server generated download link
     */
    InvoiceApi.prototype.downloadStatementsByLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadStatementsByLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Emails selected invoices (if multiple invoices, attachments will be zipped)
     */
    InvoiceApi.prototype.emailInvoicesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling emailInvoices.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling emailInvoices.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.isCombined !== undefined) {
                            queryParameters['isCombined'] = requestParameters.isCombined;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice/email".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.EmailInvoicesRequestToJSON(requestParameters.emailInvoicesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Emails selected invoices (if multiple invoices, attachments will be zipped)
     */
    InvoiceApi.prototype.emailInvoices = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailInvoicesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emails selected statements (if multiple statements, attachments will be zipped)
     */
    InvoiceApi.prototype.emailStatementsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling emailStatements.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling emailStatements.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.excludePaidInvoices !== undefined) {
                            queryParameters['excludePaidInvoices'] = requestParameters.excludePaidInvoices;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/statement/email".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.EmailStatementsRequestToJSON(requestParameters.emailStatementsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Emails selected statements (if multiple statements, attachments will be zipped)
     */
    InvoiceApi.prototype.emailStatements = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailStatementsRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets account details for a customer id
     */
    InvoiceApi.prototype.getAccountDetailsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getAccountDetails.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/details".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccountDetailsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets account details for a customer id
     */
    InvoiceApi.prototype.getAccountDetails = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccountDetailsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets statement details - used for account summary
     */
    InvoiceApi.prototype.getAccountSummaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getAccountSummary.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/statementAccountSummary".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.StatementFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets statement details - used for account summary
     */
    InvoiceApi.prototype.getAccountSummary = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccountSummaryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the details for an invoice
     */
    InvoiceApi.prototype.getInvoiceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getInvoice.');
                        }
                        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
                            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling getInvoice.');
                        }
                        if (requestParameters.invoiceSuffixId === null || requestParameters.invoiceSuffixId === undefined) {
                            throw new runtime.RequiredError('invoiceSuffixId', 'Required parameter requestParameters.invoiceSuffixId was null or undefined when calling getInvoice.');
                        }
                        queryParameters = {};
                        if (requestParameters.erp !== undefined) {
                            queryParameters['erp'] = requestParameters.erp;
                        }
                        if (requestParameters.includeItems !== undefined) {
                            queryParameters['includeItems'] = requestParameters.includeItems;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice/{invoiceId}/{invoiceSuffixId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "invoiceId" + "}", encodeURIComponent(String(requestParameters.invoiceId))).replace("{" + "invoiceSuffixId" + "}", encodeURIComponent(String(requestParameters.invoiceSuffixId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.InvoiceFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the details for an invoice
     */
    InvoiceApi.prototype.getInvoice = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInvoiceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets invoices for a customer id and date range
     */
    InvoiceApi.prototype.getInvoicesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getInvoices.');
                        }
                        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
                            throw new runtime.RequiredError('fromDate', 'Required parameter requestParameters.fromDate was null or undefined when calling getInvoices.');
                        }
                        queryParameters = {};
                        if (requestParameters.fromDate !== undefined) {
                            queryParameters['fromDate'] = requestParameters.fromDate;
                        }
                        if (requestParameters.toDate !== undefined) {
                            queryParameters['toDate'] = requestParameters.toDate;
                        }
                        if (requestParameters.productId !== undefined) {
                            queryParameters['productId'] = requestParameters.productId;
                        }
                        if (requestParameters.salesOrderNumber !== undefined) {
                            queryParameters['salesOrderNumber'] = requestParameters.salesOrderNumber;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.reference !== undefined) {
                            queryParameters['reference'] = requestParameters.reference;
                        }
                        if (requestParameters.invoiceNumber !== undefined) {
                            queryParameters['invoiceNumber'] = requestParameters.invoiceNumber;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.greaterThan !== undefined) {
                            queryParameters['greaterThan'] = requestParameters.greaterThan;
                        }
                        if (requestParameters.lessThan !== undefined) {
                            queryParameters['lessThan'] = requestParameters.lessThan;
                        }
                        if (requestParameters.comment !== undefined) {
                            queryParameters['comment'] = requestParameters.comment;
                        }
                        if (requestParameters.pwgoOnly !== undefined) {
                            queryParameters['pwgoOnly'] = requestParameters.pwgoOnly;
                        }
                        if (requestParameters.includeZeroDollarInvoices !== undefined) {
                            queryParameters['includeZeroDollarInvoices'] = requestParameters.includeZeroDollarInvoices;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.InvoicesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets invoices for a customer id and date range
     */
    InvoiceApi.prototype.getInvoices = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInvoicesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a link for a payment
     */
    InvoiceApi.prototype.getPaymentLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getPaymentLink.');
                        }
                        if (requestParameters.amount === null || requestParameters.amount === undefined) {
                            throw new runtime.RequiredError('amount', 'Required parameter requestParameters.amount was null or undefined when calling getPaymentLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.amount !== undefined) {
                            queryParameters['amount'] = requestParameters.amount;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/payment".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PaymentLinkFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets a link for a payment
     */
    InvoiceApi.prototype.getPaymentLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPaymentLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a link for a payment and uploads files
     */
    InvoiceApi.prototype.getPaymentLinkWithFileUploadRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getPaymentLinkWithFileUpload.');
                        }
                        if (requestParameters.amount === null || requestParameters.amount === undefined) {
                            throw new runtime.RequiredError('amount', 'Required parameter requestParameters.amount was null or undefined when calling getPaymentLinkWithFileUpload.');
                        }
                        queryParameters = {};
                        if (requestParameters.amount !== undefined) {
                            queryParameters['amount'] = requestParameters.amount;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.file) {
                            requestParameters.file.forEach(function (element) {
                                formParams.append('file', element);
                            });
                        }
                        return [4 /*yield*/, this.request({
                                path: "/user/admin/customer/{customerId}/payment".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PaymentLinkFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets a link for a payment and uploads files
     */
    InvoiceApi.prototype.getPaymentLinkWithFileUpload = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPaymentLinkWithFileUploadRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets statements for a customer id
     */
    InvoiceApi.prototype.getStatementsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getStatements.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/statement".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.StatementsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets statements for a customer id
     */
    InvoiceApi.prototype.getStatements = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStatementsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Notifies the server that a payment has been completed
     */
    InvoiceApi.prototype.notifyPaymentCompleteRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling notifyPaymentComplete.');
                        }
                        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                            throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling notifyPaymentComplete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/payment/{sessionId}/complete".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "sessionId" + "}", encodeURIComponent(String(requestParameters.sessionId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Notifies the server that a payment has been completed
     */
    InvoiceApi.prototype.notifyPaymentComplete = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notifyPaymentCompleteRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Requests credit limit change for an account by sending an email to support with included user details
     */
    InvoiceApi.prototype.requestCreditLimitChangeRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling requestCreditLimitChange.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/creditLimit/requestChange".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.RequestCreditLimitChangeRequestToJSON(requestParameters.requestCreditLimitChangeRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Requests credit limit change for an account by sending an email to support with included user details
     */
    InvoiceApi.prototype.requestCreditLimitChange = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestCreditLimitChangeRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets the comment on an invoice
     */
    InvoiceApi.prototype.setInvoiceCommentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling setInvoiceComment.');
                        }
                        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
                            throw new runtime.RequiredError('invoiceId', 'Required parameter requestParameters.invoiceId was null or undefined when calling setInvoiceComment.');
                        }
                        if (requestParameters.invoiceSuffixId === null || requestParameters.invoiceSuffixId === undefined) {
                            throw new runtime.RequiredError('invoiceSuffixId', 'Required parameter requestParameters.invoiceSuffixId was null or undefined when calling setInvoiceComment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/invoice/{invoiceId}/{invoiceSuffixId}/comment".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "invoiceId" + "}", encodeURIComponent(String(requestParameters.invoiceId))).replace("{" + "invoiceSuffixId" + "}", encodeURIComponent(String(requestParameters.invoiceSuffixId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.SetInvoiceCommentRequestToJSON(requestParameters.setInvoiceCommentRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sets the comment on an invoice
     */
    InvoiceApi.prototype.setInvoiceComment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setInvoiceCommentRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return InvoiceApi;
}(runtime.BaseAPI));
exports.InvoiceApi = InvoiceApi;
